import { useMutation } from 'react-query';

import {
  CreateLandingPageLeadParams,
  CreateLandingPageLeadResponse,
  createLandingPageLead,
} from '@utils/backend-api/landingPage';

export default function useLandingPageLeadCreate() {
  const { mutate, mutateAsync, data, isLoading } = useMutation(
    (params: CreateLandingPageLeadParams) => createLandingPageLead(params),
    {
      onSuccess: (response: CreateLandingPageLeadResponse) => {
        const redirectUrl = response.redirectUrl || (response as any).redirectURL;
        if (redirectUrl) {
          window.location.href = redirectUrl;
        }
      },
    }
  );

  return { mutate, mutateAsync, data, isLoading };
}
